import { addDays } from "date-fns";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { FiCalendar, FiChevronDown, FiFilter, FiSearch } from "react-icons/fi";
import DashboardStyle from "../../../dashboard/Styles/Dashboard.module.css";
import {
  ActionButtons,
  SupportButtons,
} from "../../../global/components/Buttons/buttons";
import { AppModalTemplate } from "../Modals/Modals";
import "./DatePicker.css";
import FilterSearch from "./Filter.module.css";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

export function SearchFilter({
  text,
  fromHeader,
  value,
  label,
  placeholder,
  className,
}) {
  const ref = useRef(null);

  // useEffect(() => {
  //   const timeOutId = setTimeout(() => text(query), 1000);
  //   return () => clearTimeout(timeOutId);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [query]);

  const handleAutoFocus = () => {
    ref.current.focus();
  };
  return (
    <div className={className}>
      {fromHeader === true ? (
        ""
      ) : (
        <label htmlFor="">{label ? label : "Search"}</label>
      )}
      <div onClick={handleAutoFocus} className={FilterSearch.Search}>
        <FiSearch className={FilterSearch.Icon} />
        <input
          onChange={(e) => text(e.target.value)}
          ref={ref}
          placeholder={placeholder || "Search"}
          type="text"
          value={value}
        />
      </div>
    </div>
  );
}

export function SearchFilterFinance({
  value,
  onChange,
  fromHeader,
  label,
  placeholder,
}) {
  const ref = useRef(null);

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const handleAutoFocus = () => {
    ref.current.focus();
  };

  // Debounced onChange handler
  const debouncedOnChange = useRef(debounce(onChange, 1000)).current;

  const handleChange = (e) => {
    const value = e.target.value;
    debouncedOnChange(value);
  };

  return (
    <div>
      {fromHeader === true ? (
        ""
      ) : (
        <label htmlFor="">{label ? label : "Search"}</label>
      )}
      <div onClick={handleAutoFocus} className={FilterSearch.Search}>
        <FiSearch className={FilterSearch.Icon} />
        <input
          onChange={handleChange}
          ref={ref}
          placeholder={placeholder || "Search"}
          type="text"
          value={value}
        />
      </div>
    </div>
  );
}

// export function ProDropFilter({ filterBy, setFilter, filter, name, onChange }) {
//   return (
//     <div>
//       <label htmlFor={name}>{name}</label>
//       <div className={`${FilterSearch.Search} ${FilterSearch.Search_Select}`}>
//         {/* {!filter?.filter ? "Filter" : filter?.name} */}
//         <select
//           onChange={(e) => {
//             setFilter(e.target.value);
//             onChange(e)
//           }}
//           name={name}
//           id={name}
//           value={filter}
//           defaultValue=""
//         >
//           <option value="">{name}</option>
//           {filterBy?.map(({ name, filter, onClick }, index) => (
//             <option onClick={onClick} key={index} value={filter}>
//               {name}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// }

export function ProDropFilter({
  filterBy,
  setFilter,
  filter,
  name,
  onChange,
  className,
  hideLabel,
}) {
  return (
    <div>
      {!hideLabel && <label htmlFor={name}>{name}</label>}
      <div
        className={`${FilterSearch.Search} ${FilterSearch.Search_Select} ${className}`}
      >
        <select
          onChange={(e) => {
            setFilter(e.target.value);
            if (onChange) onChange(e); // Check if onChange is defined before calling it
          }}
          name={name}
          id={name}
          value={filter}
          defaultValue=""
        >
          <option value="">{name}</option>
          {filterBy?.map(({ name, filter, onClick }, index) => (
            <option onClick={onClick} key={index} value={filter}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export function ProDropFilterMd({ filterBy, setFilter, filter, name }) {
  return (
    <div className={`${FilterSearch.Search} ${FilterSearch.Search_Select_md}`}>
      {/* {!filter?.filter ? "Filter" : filter?.name} */}
      <select onChange={(e) => setFilter(e.target.value)} name="" id="">
        <option value="">{name}</option>
        {filterBy?.map(({ name, filter }, index) => (
          <option key={index} value={filter}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
}

export function ActionFilter({
  filterBy,
  setFilter,
  filter,
  name,
  placeholder,
}) {
  return (
    <div>
      <div className={`${FilterSearch.Action_Filter}`}>
        {/* {!filter?.filter ? "Filter" : filter?.name} */}
        <select
          onChange={(e) => setFilter(e.target.value)}
          name={name}
          id={name}
          placeholder={placeholder}
        >
          <option value="">{placeholder}</option>
          {filterBy?.map(({ name, filter }, index) => (
            <option key={index} value={filter}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export function ActionButton({
  filterBy,
  setFilter,
  filter,
  name,
  placeholder,
  onChange,
  disabled,
  style,
}) {
  return (
    <div
      style={{ maxWidth: "100px" }}
      className={`${FilterSearch.Action_Filter}`}
    >
      {/* <label htmlFor={name}>{name}</label> */}
      <div
        style={style ?? {}}
        className={FilterSearch.Search}
        onChange={() => onChange()}
      >
        <select
          onChange={(e) => setFilter(e.target.value)}
          name={name}
          id={name}
          placeholder={placeholder}
          style={style ?? {}}
          disabled={disabled === "disabled" ? true : false}
        >
          <option value="">{placeholder}</option>
          {filterBy?.map(({ name, filter }, index) => (
            <option key={index} value={filter}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export function FilterButton({ filterBy, setFilter, filter, name, onClick }) {
  return (
    <div
      onClick={() => onClick()}
      style={{ height: "100%", maxWidth: "100px" }}
    >
      <label htmlFor={name}>{name}</label>
      <div
        style={{ padding: "0.56rem 0.6rem" }}
        className={FilterSearch.Search}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0px 8px",
          }}
        >
          {" "}
          <FiFilter className={FilterSearch.Icon} />
          <p>Filter</p>
        </div>
        <input placeholder={"Search"} type="button" />
      </div>
    </div>
  );
}

// FilterButton component
export function FilterButtonNew({ name, onClick }) {
  const handleButtonClick = () => {
    onClick(); // Call the onClick function passed as a prop
  };

  return (
    <div onClick={handleButtonClick} style={{ cursor: "pointer" }}>
      <label htmlFor={name}>{name}</label>
      <button>Click Me</button>
    </div>
  );
}

export function FilterButtonWithModal({
  filterBy,
  setFilter,
  filter,
  name,
  onClick,
}) {
  let [modalOpen, setModalOpen] = useState(false);

  return (
    <div
      onClick={() => setModalOpen(true)}
      style={{ height: "100%", maxWidth: "100px" }}
    >
      <label htmlFor={name}>{name}</label>
      <div
        style={{ padding: "0.56rem 0.6rem" }}
        className={FilterSearch.Search}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0px 8px",
          }}
        >
          {" "}
          <FiFilter className={FilterSearch.Icon} />
          <p>Filter</p>
        </div>
        <input placeholder={"Search"} type="button" />
      </div>
      <AppModalTemplate
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        hasCancel={true}
        closeFunction={() => setModalOpen(false)}
      >
        <div>
          {filterBy?.map((item, i) => {
            return (
              <div>
                {item.type === "date" && (
                  <CalendarFilter3 name={item.title} setDate={item.onChange} />
                )}
                {/* {
                item.type === 'dropdown' &&
                <FormSelectAlt name={item.title} array={item.options} />
              } */}
              </div>
            );
          })}
        </div>
        <div className="flex w-full justify-between mt-8">
          <SupportButtons
            onClick={() => setModalOpen(false)}
            width={"auto"}
            className={DashboardStyle?.button_cage_weight}
          >
            Clear Filter
          </SupportButtons>
          <ActionButtons
            // isLoading={isLoading}
            // disabled={!isValid}
            width={"auto"}
            className={DashboardStyle?.button_cage_weight}
          >
            Submit
          </ActionButtons>
        </div>
      </AppModalTemplate>
    </div>
  );
}

export function CalendarFilter({ filterBy, name, date, startDate, endDate }) {
  const pastMonth = new Date();
  const defaultSelected = {
    from: startDate,
    to: endDate,
  };
  const [range, setRange] = useState(date ? date : defaultSelected);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    // date(range);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);
  return (
    <div
      onMouseLeave={() => setOpenModal(false)}
      className={FilterSearch?.date_filter}
      style={{ maxWidth: "200px" }}
    >
      <label htmlFor={name}>{name}</label>
      {/* <style>{css}</style> */}
      <div style={{ padding: "0.7rem 0.6rem" }} className={FilterSearch.Search}>
        <div
          onClick={() => setOpenModal(!openModal)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0px 8px",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {" "}
          <FiCalendar className={FilterSearch.Icon} />
          <p style={{ fontSize: "0.71rem", display: "inline-flex" }}>
            {moment(range?.from).format("l")}–{moment(range?.to).format("l")}
          </p>
          <FiChevronDown className={FilterSearch.Icon} />
        </div>
        <input
          style={{ display: "none" }}
          placeholder={"Search"}
          type="button"
        />
      </div>
      {openModal && (
        <div className={FilterSearch?.date_filter_picker}>
          {" "}
          <DayPicker
            mode="range"
            defaultMonth={pastMonth}
            selected={range}
            // footer={footer}
            onSelect={(val) => {
              setRange(val);
              // onChange(val)
            }}
          />
        </div>
      )}
    </div>
  );
}

export function CalendarDateRangeFilter({ onChange, name }) {
  const defaultStartDate = moment().subtract(1, "month").toDate(); // One month ago
  const defaultEndDate = new Date(); // Today

  const [range, setRange] = useState({
    from: defaultStartDate,
    to: defaultEndDate,
  });
  const [openModal, setOpenModal] = useState(false);

  // useEffect(() => {
  //   // Call the onChange callback with the selected dates
  //   // range.fromformat=moment(range?.from).format("DD/MM/YYYY");
  //   // range.toformat=moment(range?.to).format("DD/MM/YYYY");
  //   // onChange(range);

  //   const formattedRange = {
  //     from: moment(range.from).format("DD/MM/YYYY"),
  //     to: moment(range.to).format("DD/MM/YYYY"),
  //   };
  //   onChange(formattedRange);
  // }, [range, onChange]);

  useEffect(() => {
    const formattedRange = {
      from: moment(range.from).format("DD/MM/YYYY"),
      to: moment(range.to).format("DD/MM/YYYY"),
    };
    onChange(formattedRange);
  }, [range]); // Include onChange as a dependency

  return (
    <div
      onMouseLeave={() => setOpenModal(false)}
      className={FilterSearch.date_filter}
      style={{ maxWidth: "200px" }}
    >
      <label htmlFor={name}>{name}</label>
      <div style={{ padding: "0.7rem 0.6rem" }} className={FilterSearch.Search}>
        <div
          onClick={() => setOpenModal(!openModal)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0px 8px",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <FiCalendar className={FilterSearch.Icon} />
          <p style={{ fontSize: "0.71rem", display: "inline-flex" }}>
            {moment(range?.from).format("DD-MMM-YY")} /{" "}
            {moment(range?.to).format("DD-MMM-YY")}
          </p>
          <FiChevronDown className={FilterSearch.Icon} />
        </div>
        <input
          style={{ display: "none" }}
          placeholder={"Search"}
          type="button"
        />
      </div>
      {openModal && (
        <div className={FilterSearch.date_filter_picker}>
          <DayPicker
            mode="range"
            defaultMonth={defaultStartDate}
            selected={range}
            onSelect={(val) => {
              setRange(val);
            }}
          />
        </div>
      )}
    </div>
  );
}

export function CalendarFilter2({
  setStartDate,
  setEndDate, 
  name,
  normalDate,
}) {
  const pastMonth = new Date();
  const defaultSelected = [moment(pastMonth), moment(addDays(pastMonth, 4))];

  const [range, setRange] = useState();
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      if (range && range[0] && range[1]) {
        if (normalDate) {
          setStartDate(range[0].format("YYYY-MM-DD"));
          setEndDate(range[1].format("YYYY-MM-DD"));
        } else {
          setStartDate(range[0].format("YYYY-MM-DDTHH:mm"));
          setEndDate(range[1].format("YYYY-MM-DDTHH:mm"));
        }
      }
    }, 500);

    return () => clearTimeout(timeoutRef.current);
  }, [range, setStartDate, setEndDate, normalDate]);

  return (
    <div style={{ position: "relative" }}>
      <label htmlFor={name}>{name}</label>
      <div>
        <RangePicker
          value={range}
          onChange={(dates) => setRange(dates)}
          className="date-range-picker"
          onClick={() => setRange([])}
        />
      </div>
    </div>
  );
}

export function CalendarFilter3({ setDate, name }) {
  const pastMonth = new Date();
  const defaultSelected = pastMonth;

  const [range, setRange] = useState(defaultSelected);

  const handleDateRange = () => {
    setDate(range);
  };

  const [openModal, setOpenModal] = useState(false);
  const [month, setMonth] = useState(new Date());
  return (
    <div
      onMouseLeave={() => setOpenModal(false)}
      className={FilterSearch?.date_filter}
      style={{ maxWidth: "200px" }}
    >
      <label htmlFor={name}>{name}</label>
      {/* <style>{css}</style> */}
      <div style={{ padding: "0.7rem 0.6rem" }} className={FilterSearch.Search}>
        <div
          onClick={() => setOpenModal(!openModal)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0px 8px",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {" "}
          <FiCalendar className={FilterSearch.Icon} />
          <p style={{ fontSize: "0.71rem", display: "inline-flex" }}>
            {moment(range?.from).format("l")}
          </p>
          <FiChevronDown className={FilterSearch.Icon} />
        </div>
        <input
          style={{ display: "none" }}
          placeholder={"Search"}
          type="button"
        />
      </div>
      {openModal && (
        <div
          className={FilterSearch?.date_filter_picker}
          onMouseLeave={handleDateRange}
        >
          {" "}
          <DayPicker
            // mode="range"
            defaultMonth={pastMonth}
            selected={range}
            // footer={footer}
            month={month}
            onSelect={setRange}
            onMonthChange={setMonth}
          />
        </div>
      )}
    </div>
  );
}
